/**
 * Thin, type-safe wrapper around the auth access-token storage location.
 *
 * Centralized here so the rest of the app never touches storage keys
 * directly. Uses `sessionStorage` (not `localStorage`): the token is a
 * bearer credential for SOAP calls, so it is kept out of storage that
 * persists across browser restarts / tabs — an expired or closed tab leaves
 * nothing behind. BFM Online never stores a password or refresh token; the
 * Barita auth server is re-engaged (via a fresh OAuth redirect) whenever the
 * session ends.
 */
const ACCESS_TOKEN_KEY = 'bfmonline.access_token';

export const tokenStorage = {
  getAccessToken(): string | null {
    return sessionStorage.getItem(ACCESS_TOKEN_KEY);
  },
  setToken(accessToken: string): void {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  },
  clear(): void {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  },
};
